import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import AuthenticationContext from '../../authorization/AuthenticationContext'
import JobStatus = com.eidu.sharedlib.entity.job.JobStatus
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type ExportEntitiesOfTypeParameters = { id: EntityTypeId; authContext: AuthenticationContext }

const exportEntitiesOfType = ({ id, authContext }: ExportEntitiesOfTypeParameters): Promise<string> =>
  fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}/entities/export`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response): Promise<string> => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from entities export endpoint`)

    return JobStatus.fromJsonString(await response.text()).jobId
  })

export default exportEntitiesOfType
